/* eslint-disable camelcase */
import React, { FC, useCallback, useMemo } from "react"
import { Appearance } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { PondCreateMultipleForm as ModelForm, ModelCreateMultipleScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { Pond } from "../../../../database"
import { goBack } from "../../../../navigators"
import { ConnectionWeakModal } from "../../farm/farm-create/farm-create-screen"

export const PondCreateMultipleScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function PondCreateMultipleScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmStore, farmId },
    pondStore: modelStore
  } = useStores();

  const initialValues = useMemo<any>(() => {
    let index = 0;
    const pondNames = farmStore.ponds.map((p) => p.name);
    return {
      farm_id: farmId,
      name_prefix: 'A',
      models: [...Array(params.total_ponds || 1)].map((v) => {
        let name = ''
        do {
          index += 1;
          name = `A${index}`;
        }
        while (pondNames.includes(name));

        return {
          name: `A${index}`
        }
      })
    }
  }, [farmId, farmStore, params.total_ponds])

  const onSuccess = useCallback((success: boolean) => {
    if (modelStore.needRefresh) {
      if (success) {
        farmStore.initWithLastBatch(() => {
          modelStore.set('needRefresh', false);
          modelStore.set('pushIdQueue', {})
        });
      } else {
        modelStore.set('needRefresh', false);
        modelStore.set('pushIdQueue', {})
      }
    }
    if (success && params.total_ponds)
      goBack('Home.Stack');
    return success;
  }, [farmStore, modelStore, params])

  return (<>
    <ModelCreateMultipleScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      Model={Pond}
      onSuccess={onSuccess}
      saveTx="pondScreen.createPond"
    />
    <ConnectionWeakModal />
  </>
  )
})
